import React from 'react';
import { Divider, Button } from 'antd';


const EmptyState = ({
  title,
  subtitle,
  graphics = null,
  btnLabel = null,
  btnIcon = null,
  btnCallback = null,
  children = null,
  ...rest,
}) => {

  return (
    <div className="d-flex flex-column align-items-center my-4">

      { graphics !== null && (
        <div style={{ width: 180, height: 186 }}>
          {graphics}
        </div>
      )}

      <div className="row my-4 align-self-stretch">
        <div className="col-12 col-lg-9 col-xl-8 mx-auto text-center">
          <h3 className="text-rounded">{ title }</h3>
          <div className="lead">{ subtitle }</div>
          { btnLabel ? (
            <Button className="mt-4" type="primary" icon={btnIcon} onClick={btnCallback}>{ btnLabel }</Button>
          ) : null }
        </div>
      </div>


      { children ? (
        <React.Fragment>
          <Divider className="mb-5" />
          { children }
        </React.Fragment>
      ) : null }

    </div>
  );

};

export { EmptyState };



// WEBPACK FOOTER //
// ./scripts/presentation/EmptyState.jsx